import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  detailsRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 10,
    paddingBottom: 10,
  },

  label: {
    color: theme.primary.textColor2,
  },

  value: {
    color: theme.primary.textColor,
  },

  batteryLevelIndicator: {
    borderRadius: 4,
    backgroundImage:
      "linear-gradient(to left, red, orange, yellow, green, darkgreen)",
    height: 15,
    marginBottom: 15,
  },
}));

export default useStyles;
